import { render, staticRenderFns } from "./vTaskView.vue?vue&type=template&id=98eddd62&"
import script from "./vTaskView.vue?vue&type=script&lang=js&"
export * from "./vTaskView.vue?vue&type=script&lang=js&"
import style0 from "./vTaskView.vue?vue&type=style&index=0&id=98eddd62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports